export default __webpack_public_path__ + "static/media/gen-int-defr.9bae7c63.png";